import { Link } from 'react-router-dom';
import CareerGrowthLogo from './CareerGrowthLogo';
import { useCookieConsentStore } from '../stores/useCookieConsentStore';

export default function Footer() {
  const openManager = useCookieConsentStore((s) => s.openManager);
  const productLinks = [
    { label: 'Find a Job', to: '/search' },
    { label: 'Pricing', to: '/pricing' },
    { label: 'Blog', to: '/blog' },
    { label: 'For recruiters', to: '/for-recruiters' },
  ];

  // Остальные юр. страницы (/ai, /aup, /privacy/sub-processors, /ca-privacy-rights,
  // /b2b/compliance) и гайды остаются доступными по роутам и перекрёстным ссылкам.
  const legalLinks = [
    { label: 'Terms & Conditions', to: '/terms' },
    { label: 'Privacy Policy', to: '/privacy' },
    { label: 'Cookie Policy', to: '/cookies' },
    { label: 'Refund Policy', to: '/refund-policy' },
    { label: 'Contacts', to: '/contacts' },
  ];

  return (
    <footer className="bg-[#1E2A3A] text-white">
      {/* Main footer */}
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row md:justify-between gap-10">
          {/* Brand */}
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-2 text-white">
              <CareerGrowthLogo hideText />
              <span className="font-bold text-xl tracking-tight">
                Job<span className="text-[#F47920]">Skills</span>
              </span>
            </Link>
            <p className="text-sm text-gray-400 mt-4 leading-relaxed">
              Smart job search and personalized interview prep with an AI agent.
              Boost your chances of success.
            </p>
          </div>

          {/* Links Grid */}
          <div className="grid grid-cols-2 gap-x-8 gap-y-10 md:gap-x-16">
            {/* Product */}
            <div>
              <h4 className="text-[11px] font-bold text-gray-500 uppercase tracking-[0.1em] mb-4">
                Product
              </h4>
              <div className="flex flex-col gap-3">
                {productLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-[14px] text-gray-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
              </div>
            </div>

            {/* Legal */}
            <div>
              <h4 className="text-[11px] font-bold text-gray-500 uppercase tracking-[0.1em] mb-4">
                Legal
              </h4>
              <div className="flex flex-col gap-3">
                {legalLinks.map((link) => (
                  <Link
                    key={link.to}
                    to={link.to}
                    className="text-[14px] text-gray-300 hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                ))}
                <button
                  type="button"
                  onClick={openManager}
                  className="text-[14px] text-gray-300 hover:text-white transition-colors text-left"
                >
                  Cookie preferences
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-6 py-6">
          <p className="text-[12px] text-gray-500">
            © 2026 Yevhenii Lisechko. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
